import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Mail = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M1.212 3.5h17.576A1.21 1.21 0 0 1 20 4.712v10.91a1.21 1.21 0 0 1-1.212 1.211H1.212A1.21 1.21 0 0 1 0 15.621V4.712A1.21 1.21 0 0 1 1.212 3.5m6.956 5.885-3.172-2.82a.938.938 0 1 0-1.247 1.402l2.376 2.11-2.376 2.114a.938.938 0 1 0 1.245 1.4l2.541-2.259 1.839 1.635a.937.937 0 0 0 1.246 0l1.839-1.635L15 13.591a.937.937 0 1 0 1.244-1.4l-2.375-2.113 2.375-2.111A.936.936 0 1 0 15 6.565l-3.153 2.804-1.851 1.642z" }) }));
});
Mail.displayName = 'Mail';
Mail.__iconComponentType = 'standard';
export default Mail;
//# sourceMappingURL=Mail.js.map